import styled from 'styled-components'

// tslint:disable-next-line
const ebCitationGuidesIcon = require('../../assets/images/eb-citation-guides.svg')

// tslint:disable-next-line
const ebPlusIcon = require('../../assets/images/eb-easybib-plus.svg')

// tslint:disable-next-line
const ebAboutUsIcon = require('../../assets/images/eb-about-us.svg')

// tslint:disable-next-line
const ebSupportIcon = require('../../assets/images/eb-support.svg')

const Menu = styled.ul`
  position: absolute;
  top: 70px;
  margin: -20px 0;
  background: ${props => props.theme.colors.white};
  padding: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(34, 25, 25, 0.1);
  border: 1px solid ${props => props.theme.colors.greyLight};
  display: none;
  z-index: 1000;
  &:hover {
    display: block;
  }
  &:before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 13px 11px;
    border-color: ${props => props.theme.colors.greyLight} transparent;
    display: block;
    width: 0;
    z-index: 0;
    top: -12px;
    right: 20px;
  }
  &:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 13px 11px;
    border-color: ${props => props.theme.colors.white} transparent;
    display: block;
    width: 0;
    z-index: 1;
    top: -11px;
    right: 20px;
  }

  & li {
    padding: 0;
    border-top: 1px solid ${props => props.theme.border.colors.greyLight};
    position: relative;
    list-style: none;
  }
  & li:first-child {
    border-top-width: 0;
  }
  & li:hover {
    cursor: pointer;
    background: ${props => props.theme.border.colors.greyLight};
  }
  & li:hover a {
    color: ${props => props.theme.colors.grey};
    cursor: pointer;
  }
  & li a {
    display: inline-block;
    padding: 6px 0 0 35px;
    color: ${props => props.theme.colors.grey};
    text-decoration: none;
    vertical-align: sub;
    padding: 0;
    font-size: 13px;
    margin: 0 0 0 5px;
  }
  & li a.icon {
    background-size: 16px;
    background-position: 3px 21px;
    background-repeat: no-repeat;
    height: 56px;
    min-width: 200px;
    padding-left: 27px;
    line-height: 450%;
  }
  & li a.icon.citation-guides {
    background-image: url(${ebCitationGuidesIcon});
  }
  & li a.icon.easybib-plus {
    background-image: url(${ebPlusIcon});
  }
  & li a.icon.about-us {
    background-image: url(${ebAboutUsIcon});
  }
  & li a.icon.support {
    background-image: url(${ebSupportIcon});
  }
  & li a.icon.projects {
    background-image: url('images/eb-projects.svg');
  }
  & li a.icon.add {
    background-image: url('images/eb-add.svg');
  }
  & li a.icon.settings {
    background-image: url('images/eb-settings.svg');
  }
  & li a.icon.logout {
    background-image: url('images/eb-logout.svg');
  }
`

export default Menu



// WEBPACK FOOTER //
// ./src/components/Header/Menu.tsx